import { styled } from "@linaria/react"

import { Dialog } from "@mui/material"
import React from "react"

import { BotegaLogo } from "./BotegaLogo"
import Button from "./Button"

const ContentWrapper = styled.div`
  padding: 0rem 0rem 4rem;
  width: calc(100%);
  height: 60vh;
  box-sizing: border-box;
`
const Content = styled.div`
  height: 100%;
  overflow-y: auto;
  padding-right: 1rem;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.1rem;

  & strong {
    font-weight: 600;
  }

  & > h1 {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 2rem;
    margin-top: 2rem;
  }

  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgb(var(--theme-color));
    border-radius: 5px;
  }

  &::-webkit-scrollbar-track {
    background-color: var(--mui-palette-background-paper);
    border-radius: 5px;
  }
`

const DISCLAIMER = (
  <>
    <h1 id="app-disclaimer">Terms of Use</h1>
    <p>
      By clicking “I accept and understand the risks” below, you agree to be bound by the terms of
      this Agreement. As such, you fully understand that:
    </p>
    <ol>
      <li>
        <p>
          <strong>Botega is a protocol built on the AO network</strong>: AO is a distributed
          computing network, similar to blockchains in terms of its decentralization. You are
          participating at your own risk.
        </p>
      </li>
      <li>
        <p>
          <strong>Testnet</strong>: The AO Network is currently operating in a testnet phase, during
          which the protocol, behavior, and other aspects of the network may be subject to
          modifications.
        </p>
      </li>
      <li>
        <p>
          <strong>Botega is offered for use “as is”</strong>: The Botega web interface and its
          backend, maintained by Krab Tech LTD, are still in development. There may be risks
          associated with bugs, security issues, and the underlying new technology.
        </p>
      </li>
      <li>
        <p>
          <strong>Subject to Change</strong>: The rules, parameters, and features of the Botega DEX
          are subject to change and upgrade. Ownership of the Botega smart contract remains with the
          Krab Tech LTD team, and there is no decentralized governance at this point.
        </p>
      </li>
      <li>
        <p>
          <strong>No Guarantees</strong>: Botega is provided without any guarantees regarding
          security or functionality. It is essential to understand that the technology may have
          vulnerabilities, and the platform is continuously evolving.
        </p>
      </li>
      <li>
        <p>
          <strong>Jurisdictional Variations</strong>: The laws that apply to your use of Botega may
          vary based on your location. We strongly encourage you to consult with legal counsel in
          your jurisdiction if you have any questions regarding your use of Botega.
        </p>
      </li>
      <li>
        <p>
          <strong>No Partnership</strong>: By using Botega, you are not entering into a partnership
          with Krab Tech LTD. Botega is a decentralized protocol provided on an “as is” basis.
        </p>
      </li>
      <li>
        <p>
          <strong>Release of Claims</strong>: You hereby release all present and future claims
          against Botega and Krab Tech LTD related to your use of the protocol and any facet of the
          protocol.
        </p>
      </li>
      <li>
        <p>
          <strong>Indemnification</strong>: You agree to indemnify and hold harmless Krab Tech LTD
          and its affiliates for any costs arising out of or relating to your use of the Botega
          protocol.
        </p>
      </li>
    </ol>
  </>
)

function Disclaimer(props: { children: React.ReactNode; defaultOpen?: boolean }) {
  const KEY = "disclaimer"
  const [hasAcknowledged, setHasAcknowledged] = React.useState(localStorage.getItem(KEY) === "true")

  const setTrue = () => {
    setHasAcknowledged(true)
    localStorage.setItem(KEY, "true")
  }

  return (
    <>
      {!hasAcknowledged && (
        <Dialog fullWidth maxWidth="md" position="top" open={!!props.defaultOpen}>
          <ContentWrapper>
            <BotegaLogo />
            <Content>
              {DISCLAIMER}
              <Button className="secondary" onClick={setTrue} style={{ marginTop: "2rem" }}>
                I understand and accept the risks
              </Button>
            </Content>
          </ContentWrapper>
        </Dialog>
      )}
      <>{props.children}</>
    </>
  )
}

export default Disclaimer
